import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import PromptList from './components/PromptList';
import PromptDetail from './components/PromptDetail';
import AddPrompt from './components/AddPrompt';
import EditPrompt from './components/EditPrompt';
import Favorites from './components/Favorites';
import AdminPanel from './components/AdminPanel';
import ToastContainer from './components/ToastContainer';
import './App.css';

function App() {
  const [currentUsername, setCurrentUsername] = useState(localStorage.getItem('username') || '');
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'success', duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type, duration }]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const handleUsernameChange = (username) => {
    setCurrentUsername(username);
    if (username) {
      localStorage.setItem('username', username);
    } else {
      localStorage.removeItem('username');
    }
  };

  return (
    <Router basename="/prompts">
      <div className="App">
        <nav className="navbar">
          <div className="container">
            <Link to="/" className="logo">AI Prompts</Link>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/add">Add Prompt</Link>
              {currentUsername && (
                <Link to="/favorites">My Favorites</Link>
              )}
              <Link to="/admin">Admin</Link>
              <div className="username-section">
                <input
                  type="text"
                  placeholder="Your username"
                  value={currentUsername}
                  onChange={(e) => handleUsernameChange(e.target.value)}
                  className="username-input"
                />
              </div>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<PromptList currentUsername={currentUsername} showToast={showToast} />} />
          <Route path="/prompts/:id" element={<PromptDetailWrapper currentUsername={currentUsername} showToast={showToast} />} />
          <Route path="/prompts/:id/edit" element={<EditPromptWrapper currentUsername={currentUsername} showToast={showToast} />} />
          <Route path="/add" element={<AddPrompt currentUsername={currentUsername} showToast={showToast} />} />
          <Route path="/favorites" element={<Favorites currentUsername={currentUsername} showToast={showToast} />} />
          <Route path="/admin" element={<AdminPanel showToast={showToast} />} />
        </Routes>

        <ToastContainer toasts={toasts} removeToast={removeToast} />
      </div>
    </Router>
  );
}

function PromptDetailWrapper({ currentUsername, showToast }) {
  const { id } = useParams();
  return <PromptDetail id={id} currentUsername={currentUsername} showToast={showToast} />;
}

function EditPromptWrapper({ currentUsername, showToast }) {
  return <EditPrompt currentUsername={currentUsername} showToast={showToast} />;
}

export default App;
